// SmallListingCard.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCar, FaGasPump, FaRoad, FaBolt } from 'react-icons/fa';
import SpecItem from './SpecItem';

const SmallListingCard = ({ listing, showHotOffer = false }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white shadow-lg hover:shadow-xl transition-shadow rounded-[2px] overflow-hidden h-full">
      <div className="relative h-40 sm:h-48">
        <img
          src={listing.images[0]}
          alt={listing.title}
          className="w-full h-full object-cover rounded-t-[2px]"
        />
        {showHotOffer && (
          <div className="absolute top-4 left-4">
            <span className="bg-[#35530A] text-white px-3 py-1 rounded-[2px] text-sm font-medium">
              Gorąca oferta
            </span>
          </div>
        )}
      </div>
      <div className="p-3 sm:p-4 flex flex-col">
        <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">
          {listing.title}
        </h3>
        <p className="text-sm text-gray-700 mb-3 sm:mb-4">
          {listing.description}
        </p>
        <div className="grid grid-cols-2 gap-2 sm:gap-3 mb-3 sm:mb-4">
          <SpecItem icon={<FaCar />} label="Rok" value={listing.year} />
          <SpecItem icon={<FaGasPump />} label="Paliwo" value={listing.fuelType} />
          <SpecItem icon={<FaRoad />} label="Przebieg" value={`${listing.mileage} km`} />
          <SpecItem icon={<FaBolt />} label="Moc" value={listing.power} />
        </div>
        <div className="flex items-center justify-between pt-2 border-t border-gray-100">
          <span className="text-base sm:text-lg font-bold text-[#35530A]">
            {listing.price.toLocaleString('pl-PL')} zł
          </span>
          <button
            onClick={() => navigate(`/listing/${listing._id}`)}
            className="bg-[#35530A] text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-[2px] hover:bg-[#2A4208] transition-colors text-sm font-medium"
          >
            Szczegóły
          </button>
        </div>
      </div>
    </div>
  );
};

export default SmallListingCard;
